'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
exports['default'] = Filters;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _pubsub = require('pubsub');

var _pubsub2 = _interopRequireDefault(_pubsub);

var _domClasslist = require('dom-classlist');

var _domClasslist2 = _interopRequireDefault(_domClasslist);

function Filters() {
	var _filterForm = document.querySelector('#filtersForm');
	//const _displayButton = document.querySelector('#displayFilters')
	var _filterList = document.querySelector('#filters');
	if (!_filterForm) return;
	var _filters = _filterForm.querySelectorAll('label');

	addHandlers();

	function addHandlers() {
		var _iteratorNormalCompletion = true;
		var _didIteratorError = false;
		var _iteratorError = undefined;

		try {
			for (var _iterator = _filters[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
				var el = _step.value;

				el.addEventListener('click', clickFilter);
			}
		} catch (err) {
			_didIteratorError = true;
			_iteratorError = err;
		} finally {
			try {
				if (!_iteratorNormalCompletion && _iterator['return']) {
					_iterator['return']();
				}
			} finally {
				if (_didIteratorError) {
					throw _iteratorError;
				}
			}
		}
	}

	/*_displayButton.addEventListener('click', function() {
 	_filterList.classList.toggle('showFilterList')
 });*/

	function clickFilter(e) {
		_pubsub2['default'].emit('load:getStatus', function (isLoading) {
			if (isLoading) {
				e.preventDefault();
			} else {
				var _labelClicked = e.target,
				    _relatedInput = _labelClicked.parentNode.querySelector('input');

				//comportement de radiobutton pour les "fake radio" (radio buttons qu'on peut uncheck > ajout de .fake-radio à l'input type checkbox)
				if ((0, _domClasslist2['default'])(_relatedInput).contains('fake-radio')) {
					var _fakeRadios = _relatedInput.parentNode.parentNode.querySelectorAll('.fake-radio');
					var _iteratorNormalCompletion2 = true;
					var _didIteratorError2 = false;
					var _iteratorError2 = undefined;

					try {
						for (var _iterator2 = _fakeRadios[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
							var el = _step2.value;

							if (el !== _relatedInput) el.checked = false;
						}
					} catch (err) {
						_didIteratorError2 = true;
						_iteratorError2 = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion2 && _iterator2['return']) {
								_iterator2['return']();
							}
						} finally {
							if (_didIteratorError2) {
								throw _iteratorError2;
							}
						}
					}
				}

				// timeout pour serialize form OK
				setTimeout(function () {
					_pubsub2['default'].emit('load:more', true);
				}, 200);
			}
		});
	}
}

module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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